export default __webpack_public_path__ + "static/media/NunitoSans-Black.6b822063.woff";